import React from "react";
import { useLocation } from "react-router-dom";

import AgentNavbar from "../../components/agent/common/Navbar";
import AdminNavbar from "../../components/admin/common/Navbar";
import MainApplicationLogs from "../../components/agent/applicationLogs/MainApplicationLogs";


const ApplicationLogs = () => {
  const location = useLocation();
  const pathname = location.pathname;

  return (
    <div className="min-h-screen">
      {pathname.includes("admin") ? (
        <AdminNavbar />
      ) : pathname.includes("agent") ? (
        <AgentNavbar />
      ) : null}

      <main className="p-4 md:p-10">
        <MainApplicationLogs />
      </main>
    </div>
  );
};

export default ApplicationLogs;

